export const strings = {
  mlModalTitle: 'Machine learning categorised line items',
  manualModalTitle: 'Manually categorised line items',
  revCounterTitle: 'Total Category Apportionment',
};

